import { createStore, applyMiddleware, compose } from 'redux';
import promise from 'redux-promise-middleware';
import loggerMiddleware from './logger-middleware';
import thunkMiddleware from 'redux-thunk';

import reducer from '../redux';
import DevTools from './devtools';
const composeEnhancers = window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] as typeof compose || compose;
const defaultMiddlewares = [
  thunkMiddleware,
  promise,
  loggerMiddleware
];
const composedMiddlewares = middlewares =>
  process.env.NODE_ENV === 'development'
    ? composeEnhancers(
        applyMiddleware(...defaultMiddlewares, ...middlewares),
      )
    : compose(applyMiddleware(...defaultMiddlewares, ...middlewares));

const initialize = (initialState={}, middlewares = []) => createStore(reducer, initialState, composedMiddlewares(middlewares));

export default initialize;
